import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  updateMakeRequest: ["make_id", "make"],
  updateMakeSuccess: ["makedata"],
  updateMakeFailure: null,
});

export const UpdateMakeTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  fetching: null,
  success: null,
  error: null,
  make_id: null,
  makedata: null,
  make: null,
});

export const UpdateMakeSelectors = {
  getData: (state: any) => state.updateMake.data,
  isFetching: (state: any) => state.updateMake.fetching,
  isSuccess: (state: any) => state.updateMake.success,
  hasError: (state: any) => state.updateMake.error,
};

export const request = (state: any, { make_id, make }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    make_id,
    make: make,
    makedata: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { makedata } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    makedata,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    makedata: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.UPDATE_MAKE_REQUEST]: request,
  [Types.UPDATE_MAKE_SUCCESS]: success,
  [Types.UPDATE_MAKE_FAILURE]: failure,
});
